import { UpgradeIds, UpgradeTypes } from '../enums'
import type { Upgrade } from '../../../../types/Upgrade'
import { DepartmentIds } from '../../departments'

const array: Upgrade[] = [
	{
		name: 'Overly personal questions',
		resource: 'ccc_exponent_1',
		id: UpgradeIds.CccExponent1,
		description:
			'The best start to a cold call is asking about their personal life.',
		cost: 1_500_500,
		effects: [
			{
				for: [DepartmentIds['Cold Call Center']],
				results: [UpgradeTypes.TwoExponentRise]
			}
		],
		conditions: {
			purchased: [DepartmentIds['Cold Call Center']]
		}
	},
	{
		name: 'Call from a different number',
		resource: 'ccc_exponent_2',
		id: UpgradeIds.CccExponent2,
		description:
			'You can never be blocked if you call from a different number every time.',
		cost: 75_000_000,
		effects: [
			{
				for: [DepartmentIds['Cold Call Center']],
				results: [UpgradeTypes.TwoExponentRise]
			}
		],
		conditions: {
			purchased: [DepartmentIds['Cold Call Center']]
		}
	},
	{
		name: 'International calls',
		resource: 'ccc_exponent_3',
		id: UpgradeIds.CccExponent3,
		description:
			"Call the world. They probably can't vote, but who's going to stop you?",
		cost: 10_500_000_000,
		effects: [
			{
				for: [DepartmentIds['Cold Call Center']],
				results: [UpgradeTypes.TwoExponentRise]
			}
		],
		conditions: {
			purchased: [DepartmentIds['Cold Call Center']]
		}
	},
	{
		name: 'Robocall Revolution',
		resource: 'ccc_exponent_4',
		id: UpgradeIds.CccExponent4,
		description:
			'Replace human callers with robots that speak every language incorrectly.',
		cost: 2_500_000_000_000,
		effects: [
			{
				for: [DepartmentIds['Cold Call Center']],
				results: [UpgradeTypes.TwoExponentRise]
			}
		],
		conditions: {
			purchased: [DepartmentIds['Cold Call Center']]
		}
	},
	{
		name: 'Time Zone Confusion',
		resource: 'ccc_exponent_5',
		id: UpgradeIds.CccExponent5,
		description:
			"Call everyone at 3 AM their time, because that's when they're most receptive.",
		cost: 500_000_000_000_000,
		effects: [
			{
				for: [DepartmentIds['Cold Call Center']],
				results: [UpgradeTypes.TwoExponentRise]
			}
		],
		conditions: {
			purchased: [DepartmentIds['Cold Call Center']]
		}
	},
	{
		name: 'Wrong Number Specialist',
		resource: 'ccc_exponent_6',
		id: UpgradeIds.CccExponent6,
		description:
			'Hire experts who exclusively dial wrong numbers, maximizing confusion.',
		cost: 100_000_000_000_000_000,
		effects: [
			{
				for: [DepartmentIds['Cold Call Center']],
				results: [UpgradeTypes.TwoExponentRise]
			}
		],
		conditions: {
			purchased: [DepartmentIds['Cold Call Center']]
		}
	},
	{
		name: 'Quantum Call Center',
		resource: 'ccc_exponent_7',
		id: UpgradeIds.CccExponent7,
		description:
			'Calls now exist in a quantum superposition of being both answered and hung up on.',
		cost: 25_000_000_000_000_000_000,
		effects: [
			{
				for: [DepartmentIds['Cold Call Center']],
				results: [UpgradeTypes.TwoExponentRise]
			}
		],
		conditions: {
			purchased: [DepartmentIds['Cold Call Center']]
		}
	}
]

export default array
